(()=>{
  if(window.yisuntrekComparisonBound)return;
  window.yisuntrekComparisonBound=true;
  let trigger;
  const bind=()=>{
    const dialog=document.getElementById('compare');
    if(!dialog||dialog.dataset.bound)return;
    dialog.dataset.bound='true';
    dialog.addEventListener('close',()=>{document.documentElement.classList.remove('comparison-open');trigger?.focus();});
  };
  const openDialog=()=>{bind();const dialog=document.getElementById('compare');if(dialog&&!dialog.open){dialog.showModal();document.documentElement.classList.add('comparison-open');}};
  document.addEventListener('click',e=>{
    const dialog=document.getElementById('compare');if(!dialog)return;
    const open=e.target.closest('[data-open-comparison],a[href="#compare"]');
    if(open){e.preventDefault();trigger=open;openDialog();}
    if(e.target.closest('[data-close-comparison]'))dialog.close();
    if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}
  });
  document.addEventListener('shopify:section:load',e=>{if(e.target.querySelector('#compare'))openDialog();});
  document.addEventListener('shopify:section:select',e=>{if(e.target.querySelector('#compare'))openDialog();});
  document.addEventListener('shopify:block:select',e=>{if(e.target.closest('#compare'))openDialog();});
  document.addEventListener('shopify:section:unload',e=>{if(e.target.querySelector('#compare'))document.documentElement.classList.remove('comparison-open');});
  bind();
})();
